var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92308 0C6.49826 5.45455e-05 6.15389 0.407036 6.15385 0.909091V9.09091H0.769231C0.344416 9.09096 4.61538e-05 9.49795 0 10V19.0909C4.61538e-05 19.593 0.344416 19.9999 0.769231 20C6.92308 20 13.0769 20 19.2308 20C19.6556 19.9999 20 19.593 20 19.0909V6.36364C20 5.86158 19.6556 5.4546 19.2308 5.45455H13.8462V0.909091C13.8461 0.407036 13.5017 5.45455e-05 13.0769 0H6.92308ZM7.69231 1.81818H12.3077V18.1818H7.69231C7.69231 12.7273 7.69231 7.27273 7.69231 1.81818ZM13.8462 7.27273H18.4615V18.1818H13.8462V7.27273ZM1.53846 10.9091H6.15385V18.1818H1.53846V10.9091Z",
    fill: "#808785"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.26f8555b079f16cc4336d91c8f878786.svg";
export { ForwardRef as ReactComponent };